require('es6-promise');
require('isomorphic-fetch');
import { createAction } from 'redux-actions';
import { getRunEnv, getUrlParam } from '../../helper/common-helper';
import fetchHelper from '../../helper/fetch-helper';
// eslint-disable-next-line
import { getTransformedLocation } from '../../helper/map-TARGET_AREA';
import config from '../../config';
import { isOversea, MAP_TYPE } from '../../helper/const';

import { formatMessage } from '../../intl/helper';
import actionText4 from '../../intl/messages/action/part4';
import actionText3 from '../../intl/messages/action/part3';
import actionText1 from '../../intl/messages/action/part1';

const setTakeawayInfo = createAction('SET_TAKEAWAY_INFO', takeawayInfo => takeawayInfo);
const setNearShopListWs = createAction('SET_NEAR_SHOP_LIST_WS', nearShopListWs => nearShopListWs);
const setNearShopListZt = createAction('SET_NEAR_SHOP_LIST_ZT', nearShopListZt => nearShopListZt);
const setNearShopListWsError = createAction('SET_NEAR_SHOP_LIST_WS_ERROR', error => error);
const setNearShopListZtError = createAction('SET_NEAR_SHOP_LIST_ZT_ERROR', error => error);
const setAllShopListWs = createAction('SET_ALL_SHOP_LIST_WS', allShopListWs => allShopListWs);
const setAllShopListZt = createAction('SET_ALL_SHOP_LIST_ZT', allShopListZt => allShopListZt);
const setAllShopListTotalPage = createAction('SET_ALL_SHOP_LIST_TOTALPAEG', options => options);
const setYCSShop = createAction('SET_YCS_SHOP', yunChengSchoolFlag => yunChengSchoolFlag);

exports.clearNearShopListWs = createAction('CLEAR_NEAR_SHOP_LIST_WS', nearShopListWs => nearShopListWs);
exports.clearNearShopListZt = createAction('CLEAR_NEAR_SHOP_LIST_ZT', nearShopListZt => nearShopListZt);
exports.clearAllShopListWs = createAction('CLEAR_ALL_SHOP_LIST_WS', allShopListWs => allShopListWs);
exports.clearAllShopListZt = createAction('CLEAR_ALL_SHOP_LIST_ZT', allShopListZt => allShopListZt);

const setCityListWs = createAction('SET_CITY_LIST_WS', citylistws => citylistws);
const setCityListZt = createAction('SET_CITY_LIST_ZT', citylistzt => citylistzt);

const setMineAddressList = createAction('SET_MINE_ADDRESS_LIST', mineAddressList => mineAddressList);
const setErrorMsg = (exports.setErrorMsg = createAction('SET_ERROR_MSG', error => error));
const setLoadMsg = (exports.setLoadMsg = createAction('SET_LOAD_MSG', loadinfo => loadinfo));

const brandId = parseInt(getUrlParam('brandId'), 10) || 0; // todo refactoring
const shopId = getUrlParam('shopId');
const uniqueId = getUrlParam('uniqueId');

exports.getCityList = (tabActive, resolve) => (dispatch, getState) => {
  const params = {
    brandId,
    shopId,
    uniqueId: 'WM',
    sendType: tabActive === 'ws' ? 2 : 3,
    runEnv: getRunEnv(),
  };

  fetchHelper
    .get(config.cityListAPI, params)
    .then(result => {
      if (result) {
        const data = result || {};
        switch (tabActive) {
          case 'ws':
            // YSC 标志
            dispatch(setYCSShop(data.yunChengSchoolFlag));
            window.ycsFlag = data.yunChengSchoolFlag;
            dispatch(setCityListWs(data));
            break;
          case 'zt':
            // YSC 标志
            dispatch(setYCSShop(data.yunChengSchoolFlag));
            window.ycsFlag = data.yunChengSchoolFlag;
            dispatch(setCityListZt(data));
            break;
          default:
            break;
        }
      }
      resolve();
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
      resolve();
    });
};

exports.getTakeawayInfo = () => (dispatch, getState) => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText1.actionLoading) }));
  fetchHelper
    .get(`${config.takeawayInfoAPI}?brandId=${brandId}&shopId=${shopId}`)
    .then(result => {
      if (result) {
        const data = result || {};
        dispatch(setTakeawayInfo(data));
        if (data.toShop === 1 && data.toHome === 1) {
          document.title = '门店列表';
        } else if (data.toShop === 1) {
          document.title = '门店列表';
        } else if (data.toHome === 1) {
          document.title = '门店列表';
        }
      }
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
    });
};

exports.getNearShopList = (curPosition = {}, tabActive, pageNum, keyWord, callBack) => (dispatch, getState) => {
  const runEnv = getRunEnv();
  const sendType = tabActive === 'ws' ? 2 : 3;
  let params = {
    brandId,
    shopId,
    uniqueId,
    pageNum,
    sendType,
    runEnv,
    // keyWord: keyWord.replace(/\s/g, ''),
    keyWord: keyWord.trim(),
  };

  if (!curPosition.isGetLoc) {
    if (window.ycsFlag === false) {
      dispatch(setErrorMsg(formatMessage(actionText3.actioncannotGetNearShop)));
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(tabActive === 'ws' ? setNearShopListWs({}) : setNearShopListZt({}));
      return;
    }
  }

  if (curPosition.isGetLoc) {
    params = {
      ...params,
      isGetLoc: curPosition.isGetLoc,
      longitude: curPosition.longitude,
      latitude: curPosition.latitude,
    };
  }

  if (isOversea) {
    params.mapType = MAP_TYPE.G_MAP;
  }

  dispatch(setLoadMsg({ status: true, word: '加载中...' }));

  fetchHelper
    .get(config.nearShopListAPI, params)
    .then(result => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (result) {
        switch (tabActive) {
          case 'ws':
            dispatch(setNearShopListWs(result));
            dispatch(setNearShopListWsError(false));
            break;
          case 'zt':
            dispatch(setNearShopListZt(result));
            dispatch(setNearShopListZtError(false));
            break;
          default:
            break;
        }

        if (callBack) {
          callBack();
        }
      }
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg || formatMessage(actionText4.actioninternetAnomaly)));
      dispatch(tabActive === 'ws' ? setNearShopListWsError(true) : setNearShopListZtError(true));
    });
};

const allShopListPageMgr = {
  NO_LIMIT_NUM: -1,
  getTotalPageName(tabActive) {
    return `totalPage${(tabActive || 'ws').toUpperCase()}`;
  },
  validate({ getState, dispatch, tabActive, pageNum }) {
    const totalPageName = this.getTotalPageName(tabActive);
    const outTotalPage = getState()[totalPageName];

    if (outTotalPage !== this.NO_LIMIT_NUM && pageNum > outTotalPage) {
      dispatch(setErrorMsg(formatMessage(actionText4.actionnomoreShopInfo)));
      dispatch(setLoadMsg({ status: false }));
      return false;
    }

    return true;
  },
  savePageTotal({ dispatch, tabActive, outTotalPage }) {
    dispatch(
      setAllShopListTotalPage({
        name: this.getTotalPageName(tabActive),
        outTotalPage: outTotalPage || this.NO_LIMIT_NUM,
      }),
    );
  },
};

exports.getAllShopList = (chosenPosition = {}, curPosition = {}, chosenPositionSendToPage = {}, tabActive, pageNum, keyWord, callBack) => (
  dispatch,
  getState,
) => {
  if (!chosenPosition.isGetLoc) {
    // 定位超时
    dispatch(setErrorMsg(formatMessage(actionText3.actioncityLocateFailed)));
    dispatch(setLoadMsg({ status: false, word: '' }));
    return;
  }

  const sendType = tabActive === 'ws' ? 2 : 3;
  let formatPoint = {};
  if (chosenPositionSendToPage.latitude && chosenPositionSendToPage.longitude) {
    formatPoint = chosenPositionSendToPage;
  } else {
    if (!curPosition.isGetLoc) {
      formatPoint = Object.assign({}, curPosition, { isGetLoc: false, latitude: '', longitude: '' });
    } else {
      formatPoint = curPosition;
    }
  }

  const params = {
    shopId,
    brandId,
    sendType,
    pageNum,
    uniqueId,
    // keyWord: keyWord.replace(/\s/g, ''),
    keyWord: keyWord.trim(),
    cityId: chosenPosition.cityId,
    longitude: formatPoint.longitude,
    latitude: formatPoint.latitude,
    isGetLoc: formatPoint.isGetLoc,
    runEnv: getRunEnv(),
  };

  if (isOversea) {
    params.mapType = MAP_TYPE.G_MAP;
  }

  if (!allShopListPageMgr.validate({ getState, tabActive, dispatch, pageNum })) {
    return;
  }

  dispatch(setLoadMsg({ status: true, word: '加载中...' }));
  fetchHelper
    .get(config.takeawayAllShopListAPI, params)
    .then(result => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (result) {
        if (result.length === 0) {
          dispatch(setErrorMsg(formatMessage(actionText4.actionnomoreShopInfo)));
          return;
        }

        switch (tabActive) {
          case 'ws':
            dispatch(setAllShopListWs(result));
            break;
          case 'zt':
            dispatch(setAllShopListZt(result));
            break;
          default:
            break;
        }

        const { outTotalPage } = result || {};
        allShopListPageMgr.savePageTotal({ dispatch, tabActive, outTotalPage });
        if (callBack) {
          callBack();
        }
      }
      dispatch(setLoadMsg({ status: false, word: '' }));
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
    });
};

// YCS
exports.getYCSAllShopList = (object, callback) => (dispatch, getState) => {
  // object { tabActive, pageNum, keyWord, dinningRoomIndex}
  const { tabActive, pageNum, keyWord, dinningRoomIndex } = object;
  const currentDinningRoom = parseInt(dinningRoomIndex, 10);
  const sendType = tabActive === 'ws' ? 2 : 3;
  const runEnv = getRunEnv();
  const params =
    `?shopId=${shopId}&brandId=${brandId}&sendType=${sendType}` +
    // `&pageNum=${pageNum}&keyWord=${keyWord.replace(/\s/g, '')}&uniqueId=${uniqueId}&dinningRoomIndex=${currentDinningRoom}&runEnv=${runEnv}`;
    `&pageNum=${pageNum}&keyWord=${keyWord.trim()}&uniqueId=${uniqueId}&dinningRoomIndex=${currentDinningRoom}&runEnv=${runEnv}`;

  if (!allShopListPageMgr.validate({ getState, tabActive, dispatch, pageNum })) {
    return;
  }

  dispatch(
    setLoadMsg({
      status: true,
      word: formatMessage(actionText1.actionLoading),
    }),
  );

  fetchHelper
    .get(`${config.takeawayAllShopListAPI}${params}`)
    .then(result => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (result) {
        if (result.length === 0) {
          dispatch(setErrorMsg(formatMessage(actionText4.actionnomoreShopInfo)));
          return;
        }

        switch (object.tabActive) {
          case 'ws':
            dispatch(setAllShopListWs(result));
            break;
          case 'zt':
            dispatch(setAllShopListZt(result));
            break;
          default:
            break;
        }

        const { outTotalPage } = result || {};
        allShopListPageMgr.savePageTotal({ dispatch, tabActive, outTotalPage });
        // if (callBack) {
        //   callBack();
        // }
      }
      dispatch(setLoadMsg({ status: false, word: '' }));
    })
    .catch((err = {}) => {
      dispatch(
        setLoadMsg({
          status: false,
          word: '',
        }),
      );
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
    });
};

exports.getMineAddressList = () => (dispatch, getState) => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText1.actionLoading) }));
  return fetchHelper
    .get(`${config.getAllAddressListAPI}?shopId=${shopId}`, null, { enableDefaultResponseResolve: false })
    .then((result = {}) => {
      const { data: resData = {} } = result;
      const { data, code, msg } = resData;
      if (+code === 200) {
        dispatch(setMineAddressList(data));
      } else {
        if (code !== 'NOT_LOGIN') {
          // 用户未登录
          dispatch(setErrorMsg(msg));
        }
      }
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
      console.log(err);
    });
};

exports.getCurLocation = callBack => (dispatch, getState) => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText3.actionLocating) }));
  getTransformedLocation()
    .then(result => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      callBack(
        {
          isGetLoc: true,
          uniqueId: 'WM',
          brandId,
          shopId,
          ...result,
        },
        { address: result.address, addressOk: true },
      );
    })
    .catch(error => {
      dispatch(setErrorMsg(error.message));
      dispatch(setLoadMsg({ status: false, word: '' }));
      callBack({}, { address: error.message, addressOk: false });
    });
};

exports.clearErrorMsg = () => (dispatch, getState) => dispatch(setErrorMsg(null));



// WEBPACK FOOTER //
// ./src/action/shop-list/shop-list-wm.js